// src/defaultBrandTheme.js

const DefaultAssistantConfiguration = {
    // Used to run searches with the assistant
    searchBar: {
        searchIconSelector: "",
        searchBarSiblingSelector: "",
        searchBarAnimation: "right-to-left"
    },

    // Used to create a button that, when clicked, opens the empty chat drawer
    shopWithAiButtonContainerSelector: "",

    // Used to show the assistant in the side cart after a product recommendation is received
    cartAssistant: {
        containerSelector: "",
        cartSelector: "",
        cartOpenButtonSelector: "",
        header: ""
    },

    // Unused for now, will be used to show the assistant on the PDP
    inlineAssistant: {
        containerSelector: ""
    },

    // Unused for now, will be used to show the assistant as a floating text bar
    showFloatingChatBar: false
};

export default DefaultAssistantConfiguration;